import * as React from 'react';

import { InfrastructureMicrofrontendContainer } from '../InfrastructureMicrofrontendContainer';
import { NearbyNewbuildingsLinkContainer } from '../NearbyNewbuildingsLink';
import { SpecialPromoLinkContainer } from '../SpecialPromoLink';

export const MapSelectorContainer: React.FC = () => {
  return (
    <InfrastructureMicrofrontendContainer
      headerLinks={
        <>
          <SpecialPromoLinkContainer />
          <NearbyNewbuildingsLinkContainer />
        </>
      }
    />
  );
};
